
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timothy-desmond",
      function () {
        return require("private-next-pages/timothy-desmond/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timothy-desmond"])
      });
    }
  